import { FirmaRevisionService } from "../services/firma_revision/firma-revision.service";
import { AppInjector } from "../injector";

export class Role {
  public database: string = "";
  private firmaService: FirmaRevisionService;

  constructor() {
    // Inyección manual del servicio
    const injector = AppInjector.getInjector();
    this.firmaService = injector.get(FirmaRevisionService);
  }
  /* comprobar roles */
  public checkRole() {
    try {
      if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
  public checkRevisionTirita() {
    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    let readonly = "";
    try {
      readonly = localStorage.getItem("readonly");
    } catch (error) {
      readonly = "";
    }
    if (readonly.localeCompare("1") == 0) {
      return false;
    } else {
      return true;
    }
  }
  public checkRevisionButtonsCancel(value) {
    try {
      if (localStorage.getItem("readonly").localeCompare("1") == 0) {
        return false;
      }
    } catch (error) {}

    if (value == null || value == undefined) {
      return false;
    }
    if (value.length > 1) {
      return true;
    }
  }
  public checkRevisionButtons(value) {
    try {
      if (localStorage.getItem("readonly").localeCompare("1") == 0) {
        return false;
      }
    } catch (error) {}

    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    if (value == null || value == undefined) {
      return true;
    }
    if (value.length > 1) {
      return false;
    } else {
      return true;
    }
  }
  public checkRevision(value) {
    try {
      if (value == null || value == undefined) {
        return false;
      } else {
        if ((value as string).length == 0) {
          return false;
        }
        if ((value as string).length > 1) {
          if ((value as string).localeCompare("-") == 0) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
    } catch (error) {
      return false;
    }
  }

  public changeValueRevision(data: any) {
    //console.log('data.revision',data.revision);

    try {
      if (
        data.revision == null ||
        data.revision == undefined ||
        data.revision.length == 0 ||
        data.revision.localeCompare("-") == 0
      ) {
        //console.log(data, this.database);
        let revision = JSON.parse(localStorage.getItem("calidad_user_tag_1"));
        //console.log(revision);

        let firma = {
          revision: revision.name,
          id: data.id,
          database: this.database,
        };
        this.firmaService
          .updateFirma(firma)
          .toPromise()
          .then((resp) => {
            //console.log( 'firma', resp );
            //this.iniciar();
          })
          .catch((error) => {
            console.log(" error", error);
          });
      } else {
        let firma = {
          revision: "-",
          id: data.id,
          database: this.database,
        };
        this.firmaService
          .updateFirma(firma)
          .toPromise()
          .then((resp) => {
            //console.log( 'firma', resp );
            //this.iniciar();
          })
          .catch((error) => {
            console.log(" error", error);
          });
      }
    } catch (error) {
      let firma = {
        revision: "-",
        id: data.id,
        database: this.database,
      };
      this.firmaService
        .updateFirma(firma)
        .toPromise()
        .then((resp) => {
          //console.log( 'firma', resp );
          //this.iniciar();
        })
        .catch((error) => {
          console.log(" error", error);
        });
    }
    // this.iniciar();
  }

  public checkRevisionandRole(value) {
    try {
      if (value == null || value == undefined) {
        return false;
      } else {
        if ((value as string).length > 1) {
          if (localStorage.getItem("role") == null) {
            return false;
          }
          if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
    } catch (error) {
      return false;
    }
  }

  /* fin de comprobar roles */
}
